import { QuoteRequestLine } from "../types";

export const computeDesignCost = ({
  designOfficeHourlyRate,
  designOfficeTime,
}: Pick<QuoteRequestLine, "designOfficeHourlyRate" | "designOfficeTime">) => {
  return ((designOfficeTime || 0) * (designOfficeHourlyRate ?? 0)) / 60;
};
